import { IRootState } from '../../../store'
import { IQuickActionsState } from '../store/quickActions.types'

export const getQuickActionsSelector = (state: IRootState): IQuickActionsState => state.quickActions
